module.exports = __webpack_public_path__ + "static/media/puzzle0103.c8b3b524.jpg";